import { render } from "./UpSellModal.vue?vue&type=template&id=65e50bf1"
import script from "./UpSellModal.vue?vue&type=script&lang=js"
export * from "./UpSellModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__